// import axiosInstance from "@/api/axios";

// export const fetchSubUsers = async (query: {
//     page: number;
//     limit: number;
//     q?: string;
//     subscribed?: boolean;
//   }) => {
//     try {
//       const response = await axiosInstance({
//         method: "GET",
//         url: `/user/api/v1/admin/users`,
//         params: {
//           page: query.page,
//           limit: query.limit,
//           ...(query.q && { q: query.q }), // Only add 'q' if it exists
//           ...(query.subscribed && { subscribed: query.subscribed }), // Only add 'subscribed' if it exists
//         },
//       });

//       console.log("Response:", response);
//       return response.data;
//     } catch (err) {
//       console.error("Error fetching stage details:", err);
//       throw err;
//     }
//   };


// export const fetchUserDetails = async (userId: string) => {
//   try {
//     const response = await axiosInstance.get(`user/api/v1/admin/users/details`, {
//       params: { id: userId }
//     });
//     return response.data;
//   } catch (error) {
//     throw new Error(
//       error instanceof Error 
//         ? error.message 
//         : 'Failed to fetch user details'
//     );
//   }
// };


import axiosInstance from "@/api/axios";

interface UserData {
  fullName?: string;
  email?: string;
  phoneNumber?: string;
  company?: string;
  productId?: string;
  stripePriceId?: string;
  countryName?: string;
  state?: string;
  city?: string;
}

export const fetchSubUsers = async (query: {
  page: number;
  limit: number;
  q?: string;
  subscribed?: boolean;
}) => {
  try {
    const response = await axiosInstance({
      method: "GET",
      url: `/user/api/v1/admin/users`,
      params: {
        page: query.page,
        limit: query.limit,
        ...(query.q && { q: query.q }), // Only add 'q' if it exists
        ...(query.subscribed && { subscribed: query.subscribed }), // Only add 'subscribed' if it exists
      },
    });
    console.log(response, "line 77")
    if (response) {
      console.log("Response:", response);
      return response?.data;
    }
  } catch (err) {
    console.error("Error fetching stage details:", err);
    throw err;
  }
};

export const fetchProducts = async (
) => {
  try {
    const response = await axiosInstance({
      method: "GET",
      url: `/odoo/api/v1/adminPanel/users/getProducts`,
      // params: {
      //   page: query.page,
      //   limit: query.limit,
      //   ...(query.q && { q: query.q }), // Only add 'q' if it exists
      // },
    });

    console.log("Response:", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching stage details:", err);
    throw err;
  }
};

export const fetchProductPrices = async (
  productId: string) => {
  try {
    const response = await axiosInstance({
      method: "GET",
      url: `/odoo/api/v1/adminPanel/users/getPriceList`,
      params: {
        productId: productId
      },
    });

    console.log("Response:", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching stage details:", err);
    throw err;
  }
};

export const fetchCountry = async () => {
  try {
    const response = await axiosInstance({
      method: "GET",
      url: `user/api/v1/admin/users/countryMasterDataForUserCreation`,
      // params: {
      //   productId:productId
      // },
    });

    console.log("Response:", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching stage details:", err);
    throw err;
  }
};

export const fetchCompany = async () => {
  try {
    const response = await axiosInstance({
      method: "GET",
      url: `odoo/api/v1/adminPanel/users/getCompanies`,
      // params: {
      //   productId:productId
      // },
    });

    console.log("Response:", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching stage details:", err);
    throw err;
  }
};

  export const  fetchGroupsForAdmin = async (query:{product_id:string}) => {
    try {
      const response = await axiosInstance({
        method: "GET",
        url: `odoo/api/v1/adminPanel/users/groups`,
        params: { productId: query.product_id },
      });
  
      console.log("Response:", response);
      return response.data;
    } catch (err) {
      console.error("Error fetching stage details:", err);
      throw err;
    }
  };

export const fetchSubUserLicenses = async (companyId:number) => {
  try {
    const response = await axiosInstance({
      method: "GET",
      url: `odoo/api/v1/adminPanel/users/subUserLicenses`,
      params: {
        companyId:companyId
      },
    });

    console.log("Response:", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching stage details:", err);
    throw err;
  }
};

export const fetchState = async (country: string) => {
  try {
    const response = await axiosInstance({
      method: "GET",
      url: `user/api/v1/admin/users/stateMasterDataForUserCreation`,
      params: {
        country: country
      },
    });

    console.log("Response:", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching stage details:", err);
    throw err;
  }
};

export const fetchCity = async (country: string, state: string) => {
  try {
    const response = await axiosInstance({
      method: "GET",
      url: `user/api/v1/admin/users/cityMasterDataForUserCreation`,
      params: {
        country: country,
        state: state
      },
    });

    console.log("Response:", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching stage details:", err);
    throw err;
  }
};
export const createUser = async (userData: UserData) => {
  try {
    const response = await axiosInstance({
      method: "POST",
      url: `odoo/api/v1/adminPanel/users/create`,
      data:
        userData
      // },
    });

    console.log("Response:", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching stage details:", err);
    throw err;
  }
};

export const fetchUserDetails = async (userId: string) => {
  try {
    const response = await axiosInstance.get(`user/api/v1/admin/users/details`, {
      params: { id: userId }
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error instanceof Error
        ? error.message
        : 'Failed to fetch user details'
    );
  }
};


export const cancelSubscription = async (email: string | undefined) => {
  try {
    const response = await axiosInstance({
      method: "POST",
      url: `/odoo/api/v1/adminPanel/users/cancelSubscription`,
      data: {
        email: email,
      },
    });

    console.log("Response:", response);
    return response.data;
  } catch (err) {
    console.error("Error cancel subs", err);
    throw err;
  }
};
